import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'react-bootstrap'
import cn from 'classnames'

import * as s from './SubmitButton.module.scss'

const SubmitButton = ({ title, loading, className }) => {
  return (
    <button type="submit" className={cn(s.formButton, className)}>
      {loading ? <Spinner animation="border" role="status" size="sm" /> : title}
    </button>
  )
}

export default SubmitButton

SubmitButton.defaultProps = {
  loading: false,
  title: 'Submit',
  className: '',
}

SubmitButton.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  className: PropTypes.string,
}
